/** Renders the dialog requested through `confirmDialog`. Mounted once, at the app root. */
import { Dialog } from './Dialog.tsx'
import { useDialogs } from './dialog-store.ts'
import { useI18n } from '../../lib/i18n/i18n-store.ts'

export function DialogHost() {
  const current = useDialogs((s) => s.current)
  const settle = useDialogs((s) => s.settle)
  const { t } = useI18n()
  if (!current) return null

  const actions = current.actions ?? [{ id: 'confirm', label: t('common.confirm'), tone: 'primary' as const }]
  return (
    <Dialog
      key={current.id}
      title={current.title}
      onDismiss={() => settle(null)}
      footer={
        <>
          <button className="btn btn--ghost" onClick={() => settle(null)}>
            {current.cancelLabel ?? t('common.cancel')}
          </button>
          {actions.map((a, i) => (
            <button
              key={a.id}
              className={`btn ${a.tone === 'danger' ? 'btn--danger' : a.tone === 'primary' ? 'btn--primary' : ''}`}
              onClick={() => settle(a.id)}
              {...(i === actions.length - 1 && a.tone !== 'danger' ? { 'data-autofocus': '' } : {})}
            >
              {a.label}
            </button>
          ))}
        </>
      }
    >
      {current.body && <p>{current.body}</p>}
    </Dialog>
  )
}
